export const GET_REMOTE_USER = "GET_REMOTE_USER"
export const MUTE = "MUTE"
export const CONNECT_ROOM = "CONNECT_ROOM"
export const DISCONNECT_ROOM = "DISCONNECT_ROOM"
